import "./Montserrat-Regular-normal";
import "./Montserrat-Medium-normal";
import "./Montserrat-SemiBold-normal";
import "./Montserrat-Bold-normal";
import "./Montserrat-ExtraBold-normal";
import "./Montserrat-Bold-italic";
